import * as React from 'react';
import { connect } from 'react-redux';

import { AppState } from 'common/appState';
import {
    ArchiveBenefitRequest,
    Benefit,
    BenefitPathParams,
    UnarchiveBenefitRequest,
} from 'features/benefit/models/benefitModels';
import {
    getMyBenefitsSuccess,
    deleteBenefitRequest,
    toggleMultipleEmployeesRoleRequest,
    toggleMultipleInvitePendingExecutiveUsersRoleRequest,
    archiveBenefitRequest,
    unarchiveBenefitRequest,
} from 'features/benefit/actions';
import {
    getMyBenefits,
    getFilteringBenefitsStatus,
} from 'features/benefit/selectors/benefitSelectors';
import {
    saveFilters,
    autocompleteRequest,
    clearFilters,
    paginationRequest,
} from 'features/pagination/actions/paginationActions';
import { PaginationFilters } from 'features/pagination/reducers/paginationReducer';
import { getFilterParams } from 'features/pagination/selectors/paginationSelectors';
import { PaginationView } from 'features/pagination/models/paginationModel';
import { RouteParams, getPageNumber } from 'common/selectors/routeSelectors';
import { isTenant, isAdmin } from 'features/user/selectors/userSelectors';
import { redirectToUrl } from 'common/actions/navigationAction';

import { EditMyBenefits as EditMyBenefitsComponent } from '../components/EditMyBenefits';

export interface EditMyBenefitsStateProps {
    myBenefits: Benefit[];
    isFiltered: boolean;
    isUserAdmin: boolean;
    tenant: boolean;
    filter?: PaginationFilters;
    pageNumber?: number;
}

interface EditMyBenefitsDispatchProps {
    deleteBenefitRequest: typeof deleteBenefitRequest;
    archiveBenefitRequest: typeof archiveBenefitRequest;
    unarchiveBenefitRequest: typeof unarchiveBenefitRequest;
    getMyBenefitsSuccess: typeof getMyBenefitsSuccess;
    redirectToUrl: typeof redirectToUrl;
    autocompleteRequest: typeof autocompleteRequest;
    clearFilters: typeof clearFilters;
    saveFilters: typeof saveFilters;
    paginationRequest: typeof paginationRequest;
    toggleMultipleEmployeesRoleRequest: typeof toggleMultipleEmployeesRoleRequest;
    toggleMultipleInvitePendingExecutiveUsersRoleRequest: typeof toggleMultipleInvitePendingExecutiveUsersRoleRequest;
    test: typeof test;
}

export type EditMyBenefitsProps = EditMyBenefitsDispatchProps &
    EditMyBenefitsStateProps &
    RouteParams;

export class EditMyBenefits extends React.Component<EditMyBenefitsProps> {
    public deleteBenefit = (benefitId: number, contractId: number) => {
        const deleteBenefitData: BenefitPathParams = {
            benefitId,
            contractId,
        };

        this.props.deleteBenefitRequest(deleteBenefitData);
    };
    public archiveBenefit = (id: number, organisationId: number, contractId: number) => {
        const archiveBenefitData: ArchiveBenefitRequest = {
            id,
            organisationId,
            contractId,
        };

        this.props.archiveBenefitRequest(archiveBenefitData);
    };
    public unarchiveBenefit = (id: number, organisationId: number, contractId: number) => {
        const unarchiveBenefitData: UnarchiveBenefitRequest = {
            id,
            organisationId,
            contractId,
        };

        this.props.unarchiveBenefitRequest(unarchiveBenefitData);
    };

    public render(): JSX.Element {
        return (
            <EditMyBenefitsComponent
                deleteBenefit={this.deleteBenefit}
                archiveBenefit={this.archiveBenefit}
                unarchiveBenefit={this.unarchiveBenefit}
                {...this.props}
            />
        );
    }
}

const mapStateToProps = (state: AppState, ownProps: RouteParams): EditMyBenefitsStateProps => ({
    myBenefits: getMyBenefits(state),
    isFiltered: getFilteringBenefitsStatus(state),
    isUserAdmin: isAdmin(state),
    tenant: isTenant(state),
    filter:
        getFilterParams(state, PaginationView.MyBenefits) ||
        getFilterParams(state, PaginationView.Benefits),
    pageNumber: getPageNumber(ownProps),
});

export const EditMyBenefitsContainer = connect(mapStateToProps, {
    deleteBenefitRequest,
    archiveBenefitRequest,
    unarchiveBenefitRequest,
    getMyBenefitsSuccess,
    redirectToUrl,
    autocompleteRequest,
    clearFilters,
    saveFilters,
    paginationRequest,
    toggleMultipleEmployeesRoleRequest,
    toggleMultipleInvitePendingExecutiveUsersRoleRequest,
})(EditMyBenefits);
